import ImageSlider from "./common/ImageSlider";
import Header from "./Header";
import Footer from "./Footer";
import ProjectInfo from "./project-details/ProjectInfo";
import ProjectDescription from "./project-details/ProjectDescription";

const Playstation = () => {
  const images = [
    "assets/img/portfolio/playstation.png",
    "assets/img/portfolio/playstation2.png",
    "assets/img/portfolio/playstation3.png",
  ];

  return (
    <>
      <Header />
      <main id="main">
        <section className="portfolio-details">
          <div className="container">
            <div className="row gy-4">
              <ImageSlider images={images} />

              <div className="col-lg-4">
                <ProjectInfo stack="React.js, Next.JS" />
                <ProjectDescription descriptionKey="playStationDesc" />
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default Playstation;
